import * as mutationTypes from './mutation-types'
import Lockr from 'lockr'

export const setToken = ({commit}, data) => {
  let expiredAt = data.expiredAt
  commit(mutationTypes.SET_TOKEN, {token: data.token, expiredAt: expiredAt})
}

export const setCurrentUser = ({commit}, data) => {
  commit(mutationTypes.SET_CURRENT_USER, data)
}

export const clean = ({commit}) => {
  commit(mutationTypes.SET_TOKEN, {})
  commit(mutationTypes.SET_CURRENT_USER, {})
  Lockr.flush()
}



// WEBPACK FOOTER //
// ./src/store/actions.js